import { Button } from "@/components/ui/button";
import NewsCard from "@/components/NewsCard";
import { getLatestNews } from "@/data/newsData";
import { Link } from "react-router-dom";

const LatestNews = () => {
  const latestArticles = getLatestNews(3);

  return (
    <section className="py-20 px-6 bg-background">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Latest News & <span className="text-primary">Insights</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {latestArticles.map((article) => (
            <NewsCard key={article.id} article={article} showExcerpt={false} />
          ))}
        </div>
        
        <div className="text-center">
          <Button variant="secondary" size="lg" asChild>
            <Link to="/news">
              View all news
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;